import type { EmploymentStatus, Status } from "@ifa/utils";

/**
 * MemberSelector 常量定义
 */

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_TITLE = "選擇成員";

export const ALL_TEAMS_ID = null;
export const ALL_TEAMS_LABEL = "全部團隊";

export const EMPTY_TEXTS = {
  NO_TEAMS: "暫無團隊資料",
  NO_MEMBERS: "暫無可選成員",
  NO_SEARCH_RESULTS: "沒有找到符合的成員",
  NO_SELECTED: "尚未選擇成員",
  SELECT_OTHER_TEAM: "請嘗試切換其他團隊",
  TRY_OTHER_KEYWORD: "請嘗試更換搜尋關鍵字",
  SELECT_FROM_LEFT: "從左側列表中選擇成員",
};

export const CONFIRM_TEXTS = {
  CLEAR_ALL: "確認清空目前已選成員嗎？",
};

export const BUTTON_TEXTS = {
  CANCEL: "取消",
  CONFIRM: "確認選擇",
  CONFIRM_WITH_COUNT: (count: number) => `確認選擇 (${count})`,
  CLEAR: "清空",
  RESET_FILTERS: "重設篩選",
};

export const SEARCH_PLACEHOLDER = "搜尋姓名、工號或職位";
export const SEARCH_DEBOUNCE_MS = 300;

const EMPLOYMENT_STATUS_VALUES = {
  OnJob: "ON_JOB" as EmploymentStatus,
  Resigned: "RESIGNED" as EmploymentStatus,
  Vacation: "VACATION" as EmploymentStatus,
};

const ACCOUNT_STATUS_VALUES = {
  Enabled: "ENABLED" as Status,
  Disabled: "DISABLED" as Status,
  Deleted: "DELETED" as Status,
};

export const EMPLOYMENT_STATUS_LABELS: Record<EmploymentStatus, string> = {
  [EMPLOYMENT_STATUS_VALUES.OnJob]: "在職",
  [EMPLOYMENT_STATUS_VALUES.Resigned]: "離職",
  [EMPLOYMENT_STATUS_VALUES.Vacation]: "休假",
};

export const ACCOUNT_STATUS_LABELS: Record<Status, string> = {
  [ACCOUNT_STATUS_VALUES.Enabled]: "啟用",
  [ACCOUNT_STATUS_VALUES.Disabled]: "禁用",
  [ACCOUNT_STATUS_VALUES.Deleted]: "已刪除",
};

export const EMPLOYMENT_STATUS_OPTIONS = [
  {
    label: EMPLOYMENT_STATUS_LABELS[EMPLOYMENT_STATUS_VALUES.OnJob],
    value: EMPLOYMENT_STATUS_VALUES.OnJob,
  },
  {
    label: EMPLOYMENT_STATUS_LABELS[EMPLOYMENT_STATUS_VALUES.Resigned],
    value: EMPLOYMENT_STATUS_VALUES.Resigned,
  },
];

export const ACCOUNT_STATUS_OPTIONS = [
  {
    label: ACCOUNT_STATUS_LABELS[ACCOUNT_STATUS_VALUES.Enabled],
    value: ACCOUNT_STATUS_VALUES.Enabled,
  },
  {
    label: ACCOUNT_STATUS_LABELS[ACCOUNT_STATUS_VALUES.Disabled],
    value: ACCOUNT_STATUS_VALUES.Disabled,
  },
];
